import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Panel, Pill, Avatar } from "@/components/Bits";
import { CheckCircle, ClipboardText } from "@phosphor-icons/react";

export default function Admissions() {
  const [admissions, setAdmissions] = useState([]);
  useEffect(() => { api.get("/admissions").then(r => setAdmissions(r.data)); }, []);
  return (
    <div>
      <PageHeader eyebrow="Admissions" title="Approved admissions" subtitle="Every signed admission, ready to onboard." />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {admissions.map(a => (
          <div key={a.admission_id} className="bg-white rounded-3xl border border-border p-5" data-testid={`admission-${a.admission_id}`}>
            <div className="flex items-center gap-3">
              <Avatar name={a.form_data?.child_name || "Child"} />
              <div>
                <div className="font-heading font-bold">{a.form_data?.child_name}</div>
                <div className="text-xs text-ink-soft">{a.form_data?.age_group} · {a.form_data?.dob}</div>
              </div>
            </div>
            <div className="mt-3 text-sm">
              <div className="text-ink-soft">Parent:</div>
              <div className="font-medium">{a.form_data?.parent_name}</div>
              <div className="text-xs text-ink-soft mt-0.5">{a.form_data?.parent_phone}</div>
            </div>
            <div className="mt-3 flex gap-2">
              <Pill tone="sage"><CheckCircle weight="bold" size={12} className="mr-1" /> {a.status}</Pill>
              {a.signed && <Pill tone="mustard">Signed</Pill>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
